import React, { useState } from "react";

const ValidityDate = ({ formData, setFormData }) => {
  // Initialize state to track whether the validity date is set manually
  const [isDateManual, setIsDateManual] = useState(false);

  // Function to handle changes in the input field
  const handleChange = (e) => {
    const { value } = e.target;

    // If the user changes the date manually, mark it as manual
    setIsDateManual(true);

    setFormData((prevFormData) => ({
      ...prevFormData,
      validityDate: value, // Set the validity date to the user's input
    }));
  };

  return (
    <div className="flex flex-col gap-1 w-1/2  py-2">
      <label className="w-full text-sm font-normal" htmlFor="quoteNumber">
        Validity Date
      </label>
      <input
        type="date"
        placeholder=""
        className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
        id="validityDate"
        onChange={handleChange}
        value={formData.validityDate}
        name="validityDate"
      />
    </div>
  );
};

export default ValidityDate;
